import { ReactNode, useMemo } from 'react';

import { usePanelBehavior } from '~/shared/utils/usePanelBehavior';

const DEFAULT_EXCLUDE_SELECTORS = ['[role="menu"]'];

interface SidePanelProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  id?: string;
  width?: string;
  top?: number | string;
  children: ReactNode;
  className?: string;
  enableClickOutside?: boolean;
  enableEscapeKey?: boolean;
  excludeSelectors?: string[];
  onClose?: () => void; // callback to execute when panel closes
}

export default function SidePanel({
  open,
  onOpenChange,
  id,
  width = 'w-[587px]',
  top = 0,
  children,
  className = '',
  enableClickOutside = true,
  excludeSelectors = [],
  onClose,
}: SidePanelProps) {
  const mergedExcludeSelectors = useMemo(
    () => [...DEFAULT_EXCLUDE_SELECTORS, ...excludeSelectors],
    [excludeSelectors]
  );
  const { panelRef } = usePanelBehavior(
    open,
    onOpenChange,
    enableClickOutside,
    mergedExcludeSelectors,
    onClose
  );

  return (
    <div
      ref={panelRef}
      id={id}
      className={`fixed -mt[0.125px] right-0 z-[20] ${width} bg-white border-l border-primary-70 transform transition-transform duration-300 ease-in-out ${
        open ? 'translate-x-0' : 'translate-x-full'
      } ${className}`}
      style={{
        top,
        bottom: 0,
        boxShadow: '-15px 86px 57.4px -3px rgba(0, 0, 0, 0.09)',
      }}
    >
      {children}
    </div>
  );
}
